var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scope-of-works-looper"},_vm._l((_vm.items),function(node){return _c('div',[(node.type === 'scope_of_works_item')?_c('sow-item',{attrs:{"item":node}}):_vm._e(),_vm._v(" "),(node.type === 'scope_of_works_task')?_c('sow-task',{attrs:{"task":node}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }